import React from "react";
import { DevelopersPermissions } from "../../../Permissions";
import { PageTitle, CustomButton, CustomPermission } from "../../../Components";
import { useTranslate, useSelectedTheme } from "../../../Hooks";
import { UploadIcon, PlusIcon } from "../../../assets/icons";

const NewDevelopersView = () => {
  const { translate } = useTranslate("NewDevelopersView");
  const { translate: sharedTranslate } = useTranslate("Developers");
  const {
    theme: { palette },
  } = useSelectedTheme();

  return (
    <>
      <PageTitle
        title={translate("developers-page-title")}
        subTitle={translate("developers-page-subtitle")}
      >
        <CustomPermission
          permissionsList={Object.values(DevelopersPermissions)}
          permissionsId={DevelopersPermissions.CreateNewDeveloper.permissionsId}
        >
          <CustomButton
            boxShadow="xs"
            size="lg"
            variant="outlined"
            color="secondary"
            onClick={() => {
              // click action
            }}
            startIcon={
              <UploadIcon
                width="20"
                height="20"
                fill={palette.button.secondary_fg}
              />
            }
          >
            {sharedTranslate("import")}
          </CustomButton>

          <CustomButton
            boxShadow="xs"
            size="lg"
            variant="contained"
            color="primary"
            onClick={() => {}}
            startIcon={
              <PlusIcon
                width="20"
                height="20"
                fill={palette.button.primary_fg}
              />
            }
          >
            {sharedTranslate("add-new")}
          </CustomButton>
        </CustomPermission>
      </PageTitle>
    </>
  );
};

export default NewDevelopersView;
